/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

export type GradedAttemptTabMode = (typeof GradedAttemptTabMode)[keyof typeof GradedAttemptTabMode];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GradedAttemptTabMode = {
  written: 'written',
  oral: 'oral',
} as const;
